module.exports = __webpack_public_path__ + "img/tcf_6.ddcc918f.png";